import "./src/styles/global.css"
import "./src/styles/products.css"

export const onClientEntry = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    // Let Layout's own scroll-to-top effect own this instead — otherwise the
    // browser restores the old page's scroll position on back/forward and
    // races with it.
    window.history.scrollRestoration = "manual"
  }
}

// Gatsby ships its own scroll-restoration system (gatsby-react-router-scroll)
// that runs on every route change independently of anything in Layout.js —
// it records each pathname's scroll position and replays it next time that
// path is visited, which is what was overriding our scroll-to-top reset and
// landing navigations on the destination page's previous scroll position.
// Returning false disables it entirely so Layout's reset is the only thing
// controlling scroll position.
export const shouldUpdateScroll = () => false
